import { render, staticRenderFns } from "./cheques.vue?vue&type=template&id=0b4704e4&scoped=true&"
import script from "./cheques.vue?vue&type=script&lang=js&"
export * from "./cheques.vue?vue&type=script&lang=js&"
import style0 from "./cheques.vue?vue&type=style&index=0&id=0b4704e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4704e4",
  null
  
)

export default component.exports